import { RangeFilterURLMapProps, URLRangeFilterMapProps } from "./types";

export const SORT_FILTER_OPTIONS = [
  { Key: "price-high-to-low", Value: "High to Low" },
  { Key: "price-low-to-high", Value: "Low to High" },
  { Key: "a-to-z", Value: "A to Z" },
  { Key: "z-to-a", Value: "Z to A" },
];

export const ACTIVE_PRICE_PATH = "ActiveTicket.Price";
export const RETAIL_PRICE_GBP_PATH = "RetailPriceGbp";
export const TOP_SPEED_PATH = "TopSpeed";
export const MPH_PATH = "MphTime";
export const POWER_PATH = "Power";
export const CARS_PER_PAGE = 20;

export const rangeFilterURLMap: RangeFilterURLMapProps = {
  RetailPriceGbp: "retailprice",
  "ActiveTicket.Price": "ticketprice",
  TopSpeed: "topspeed",
  MphTime: "zero60",
  Power: "power",
};

export const urlRangeFilterMap: URLRangeFilterMapProps = {
  retailprice: "RetailPriceGbp",
  ticketprice: "ActiveTicket.Price",
  topspeed: "TopSpeed",
  zero60: "MphTime",
  power: "Power",
};
